<template>
  <v-card class="card-border" :shaped="true">
    <v-card-title>Total Leads Atrasados</v-card-title>
    <v-card-subtitle>{{ total }}</v-card-subtitle>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: "TotalLeadsAtrasados",

  data() {
    return {
      total: 0,
      today: new Date()
    }
  },

  computed: {
    ...mapGetters('dashboard', ['getLeads'])
  },

  methods: {
    generateGrafic(leads) {
      this.total = 0
      for (const lead of leads) {
        if (this.today > new Date(lead.dataProxContato.seconds * 1000) && lead.status == "Pendente") {
          this.total += 1
        }
      }
    }
  },

  watch: {
    getLeads(leads) {
      this.generateGrafic(leads)
    }
  },

  mounted() {
    if (this.getLeads.length !== 0) {
      this.generateGrafic(this.getLeads)
    }
  }
};
</script>
